import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteUnidadeNegocioSearch } from '../cliente-unidade-negocio-search';
import { ClienteUnidadeNegocioInsert } from '../insert/cliente-unidade-negocio-insert';

@Injectable({
    providedIn: 'root'
})
export class ClienteUnidadeNegocioHttpService {
    resource = 'cliente';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa as unidades de negócios do cliente */
    search(idCliente: number): Observable<ClienteUnidadeNegocioSearch[]> {
        return this.customHttp.get<ClienteUnidadeNegocioSearch[]>(`${this.pathApi}/${idCliente}/unidadenegocio2`);
    }

    /** Insere a unidade de negócio no cliente informado */
    insert(entityInsert: ClienteUnidadeNegocioInsert): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/${entityInsert?.idCliente}/unidadenegocio`, entityInsert);
    }
}
